import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "assign-tickets" as const;

export type AssignTicketsEventData = {
  tickets: Array<{
    quantity: number;
    exhibitorId?: string | null;
    commercialId?: string | null;
    visitorId?: string | null;
  }>;
  eventId: string;
};
export type AssignTicketsEvent = AppEvent<
  typeof eventName,
  AssignTicketsEventData
>;

export const isAssignTicketsEvent = (
  event: AnyAppEvent
): event is AssignTicketsEvent => event.name === eventName;

export { eventName as assignTickets };
